import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { handleError } from "../utilities/api.utils";

declare type GetBillingSummaryResponse = {
  Code: string;
  Message: string;
  Payload: {
    MinDue: string;
    TotalDue: string;
    DueDay: number;
    DueDate: string;
    AutopayType: string;
    Invoices: {
      DueDate: string;
      MinimumDue: string;
    }[];
    Transactions: {
      AccountNumber: string;
      amt: string;
      balance: string;
      desc: string;
      eff: string;
      pol: string;
      prem: string;
      tranEff: string;
    }[];
  };
};

export interface GetBillingSummaryResponse2 {
  autopayType: string;
  balance: number;
  dueDate: string;
  dueDay: string;
  invoices: BillingInvoice2[];  
  isAutopay: boolean;
  minimumDue: number;
  totalDue: string;  
  transactions: BillingTransaction2[];
}

export interface BillingTransaction2 {
  amount: number;
  balance: number;
  description: string;
  policyNumber: string;
  transactionDate: string;
  effectiveDate: string;
  premium: string;
}

export interface BillingInvoice2 {
  dueDate: string;
  minimumDue: string;
}

@Injectable({
  providedIn: "root",
})
export class BillingApiService {
  constructor(private http: HttpClient) {}

  getBillingSummary(accountNumber: string) {
    return this.http
      .get<GetBillingSummaryResponse2>(`${environment.moeUserApiProxyUrl}/accounts/${accountNumber}/billing-summary`)
      .pipe(
        catchError(handleError));
  }
}
